module.exports = __webpack_public_path__ + "img/Social Networker.f3d71203.png";